import { render, staticRenderFns } from "./shangjia.vue?vue&type=template&id=0f3b2946"
import script from "./shangjia.vue?vue&type=script&lang=js"
export * from "./shangjia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports